<script setup>
</script>

<template>
    <div class="
        bg-white text-white-foreground flex rounded-md border border-white-foreground/20 relative p-2
        focus-within:ring-2 focus-within:ring-black/20 focus-within:border-black/20
        ">
        <slot></slot>
    </div>
</template>
